import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

export default function AppLayout() {

  return (
    <Layout className={'min-h-screen'}>
      <Content className={'bg-secondary overflow-auto'}>
        <Outlet />
      </Content>
    </Layout>
  );
}
